import React, { useState, useEffect } from "react";
import "./Card.css";
import logo from "../../img/logo.png";
import axios from "axios";
function Card() {
  const [imgurl, setImgurl] = useState([]);
  const [phrase, setPhrase] = useState([]);
  const [quote, setquote] = useState([]);
  const [quoteauthor, setquoteauthor] = useState("");
  const [items, setItems] = useState([]);

  useEffect(() => {
    const getPhrase = async () => {
      const response = await axios(
        `https://breaking-bad-quotes.herokuapp.com/v1/quotes`
      );
      setquote(response.data[0].quote);
      setquoteauthor(response.data[0].author);
      setPhrase(response.data[0]);
      console.log(response.data[0].author);
    };
    getPhrase();
  }, []);

  useEffect(() => {
    const fetchImg = async () => {
      const result = await axios(
        `https://www.breakingbadapi.com/api/characters?name=${quoteauthor}`
      );

      setItems(result.data[0]);
    };
    fetchImg();
  }, [items]);

  return (
    <div class="car">
      <img className="quotesimg" src={items.img} alt="Avatar" />
      <div class="container">
        <h4>
          <b className="quote">{quote}</b>
        </h4>
        <p className="author">--{quoteauthor}</p>
      </div>
    </div>
  );
}

export default Card;
